<form
  (ngSubmit)="navigateToSearchPage()"
  class="flex h-[47px] w-[242px] items-center border-b-[1.5px] border-rojo pt-2">
  <div class="flex w-full items-end px-1">
    <input
      type="text"
      [formControl]="searchControl"
      (keydown.enter)="navigateToSearchPage()"
      placeholder="{{ 'forms.placeholders.search' | transloco }}"
      class="flex-1 bg-transparent font-['Roboto'] text-base font-normal sm:font-medium text-cafe placeholder-cafe focus:outline-none" />
    @if (showSearchIcon()) {
      <ln-search-svg-icon class="h-6 w-6"></ln-search-svg-icon>
    } @else {
      <button type="button" (click)="buttonSearchClose()">
        <ln-close-svg-icon class="h-6 w-6"></ln-close-svg-icon>
      </button>
    }
  </div>
</form>
